import React from "react";

const Reminder = ({ label, text }) => {
  return (
    <div className="note-container">
      <h2>
        <b>{label || ""}: </b>
        <span>{text || ""}</span>
      </h2>
    </div>
  );
};

export default Reminder;
